import { render, staticRenderFns } from "./CombinationsProductTable.vue?vue&type=template&id=9f29e9f4&scoped=true"
import script from "./CombinationsProductTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsProductTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsProductTable.vue?vue&type=style&index=0&id=9f29e9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f29e9f4",
  null
  
)

export default component.exports